import { apiRoutes } from "@constants/api-routes";
import { RequestTypes } from "@enums/request-types";
import { QueryParameter } from "@idw-types/common";
import { WorkflowChangeRequestDataResponse } from "@idw-types/data/workflow-change-request";
import { GenericNetworkResponse } from "@idw-types/generic-network-response";
import { handleRequestWithQueryParams } from "@utils/http-util";

export const getWorkflowChangeRequest = async (
    workflowId: string,
): Promise<GenericNetworkResponse<WorkflowChangeRequestDataResponse>> => {
    const queryParameters: Array<QueryParameter> = [
        { parameter: "workflowID", value: workflowId }
    ];

    const { data, error } = await handleRequestWithQueryParams(
        RequestTypes.GET,
        apiRoutes.serviceConfiguration.data.workflowChangeRequest,
        queryParameters
    );

    return { data, error, queryParameters };
};
